import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import PropTypes from 'prop-types';

const HeroImage = props => {
  return (
    <div className="overflow-h">
      <ProgressiveImage
        src={props.img.url}
        placeholder={props.img.thumbnails.small.url}
        className="ga-uni-img focus-centre"
      >
        {(src, loading) => (
          <img
            className="ga-uni-img focus-centre"
            src={src}
            alt={`${props.alt} campus`}
            style={{ width: 645, opacity: loading ? 0.5 : 1 }}
            width="645"
          />
        )}
      </ProgressiveImage>
    </div>
  );
};

export default HeroImage;

HeroImage.propTypes = {
  img: PropTypes.object.isRequired,
  alt: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/HeroImage.js